module.exports = __webpack_public_path__ + "img/gov-down2.e85c2c17.svg";